export default __webpack_public_path__ + "static/media/Custom-HUD-05.17637213.jpg";